import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { InvoiceItem } from './invoice.item';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { faPen, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
declare var $: any;

@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {
    @ViewChild('financedAmountInput') financedAmountInput: ElementRef;

    public faPen = faPen;
    public faCheck = faCheck;
    public faTimes = faTimes;

    public openEditFinancedAmountPopover = false;
    public production: boolean = environment.production;

    public items: InvoiceItem[] = [
        new InvoiceItem(this.formBuilder)
    ];

    public invoiceForm: FormGroup = this.formBuilder.group({
        financedAmountInput: ['', Validators.required]
    });

    public useNumber = new FormControl();
    private applicationId: number;
    public offers: any = {
        offerList: []
    };
    public selectedOffer: any = {};
    public selectedOfferRadio: FormControl = new FormControl();

    public statesOfIncorporation: any[] = [];

    submitted = false;

    public errorTitle = '';
    public errorMessageA = '';
    public errorMessageB = '';
    public errorMessageC = '';
    public errorMessageBClass = '';
    public dialogClass = '';

    private sendDocs = false;
    public numberOfAttempts = 0;
    public numberOfDocsExceeded = false;
    public isAmendment = false;

    constructor(
        private connectionService: ConnectionService,
        public router: Router,
        private authService: AuthService,
        private formBuilder: FormBuilder,
        private changeDetector: ChangeDetectorRef
    ) {
        const navigation = this.router.getCurrentNavigation();
        if (navigation.extras.state) {
            this.applicationId = navigation.extras.state.applicationId;
        } else {
            this.router.navigateByUrl('/');
        }
        this.useNumber.setValue('true');
    }

    ngOnInit() {
        this.getStates().then(
            () => this.getInvoice(this.applicationId).then(
                () => this.getApplicationData(this.applicationId)
            )
        );

        this.getOffers(this.applicationId).then(
            (data: any) => {
                if (data.object) {
                    this.offers = data.object;
                    this.selectedOffer = {};
                    data.object.offerList.forEach((element: any) => {
                        if (element.selected) {
                            this.selectedOffer = element;
                        }
                    });
                }
            },
            (error: any) => {
            }
        );
    }

    getStates() {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequestUnsecured(environment.gateway + 'utils/states', 'application/json').subscribe(
                (data: any) => {
                    this.statesOfIncorporation = data.object;
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
        return promise;
    }

    getInvoice(applicationId: number) {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequest(environment.gateway + 'equipment/' + applicationId, 'application/json').subscribe(
                (data: any) => {
                    if (data.object) {
                        this.items = [];
                        this.useNumber.setValue('false');
                        data.object.forEach((invoiceItem: any) => {
                            const item = new InvoiceItem(this.formBuilder);
                            item.decode(invoiceItem);
                            this.onZipCodeKeyUp(item);
                            this.items.push(item);
                        });
                        if (this.items.length === 0) {
                            this.items.push(new InvoiceItem(this.formBuilder));
                        }
                    }
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
        return promise;
    }

    getApplicationData(applicationId: number) {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequest(
                environment.gateway + 'application/' + applicationId, 'application/json', 'sp_id=' + this.authService.getSalesPersonId()).subscribe(
                    (data: any) => {
                        this.isAmendment = data.object.amendment ? true : false;
                        resolve(data);
                    },
                    (error: any) => {
                        this.isAmendment = false;
                        resolve(error);
                    }
                );
        });
        return promise;
    }

    getBalanceDue() {
        if (this.selectedOffer !== null) {
            if (this.selectedOffer.useMaxApprovedAmount) {
                if ((this.getInvoiceTotal() - this.offers.maxApproved) < 0) {
                    return 0;
                } else {
                    return this.getInvoiceTotal() - this.offers.maxApproved;
                }
            } else {
                if ((this.getInvoiceTotal() - this.offers.requestAmount) < 0) {
                    return 0;
                } else {
                    return this.getInvoiceTotal() - this.offers.requestAmount;
                }
            }
        }
    }

    getOffers(applicationId: number) {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequest(
                environment.gateway + 'application/' + applicationId + '/activeOffers/' + this.authService.getUserId(),
                'application/json', 'sp_id=' + this.authService.getSalesPersonId()).subscribe(
                    (data: any) => {
                        if (data.object) {
                        } else {
                        }
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
        return promise;
    }

    openSelectOffersDialog(sendDocs: boolean) {
        this.sendDocs = sendDocs;
        this.submitted = true;
        let invalid = false;

        this.items.forEach((item: InvoiceItem) => {
            if (item.form.invalid) {
                invalid = true;
            }
        });

        if (invalid) {
            return;
        }

        this.validateQuantity().then(
            (data: any) => {
                this.numberOfDocsExceeded = data.object.numberOfDocsExceeded;
                if (data.object.attemptNumber < 1) {
                    this.openSelectOffersDialogAfterQuantityValidation();
                } else if (data.object.attemptNumber > 0) {
                    this.numberOfAttempts = data.object.attemptNumber;
                    $('#attempModal').modal({ backdrop: 'static', keyboard: false });
                }
            },
            (error: any) => {
                this.errorTitle = 'Sorry, we found a problem';
                this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
                this.errorMessageB = error.error.msg;
                this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                this.errorMessageBClass = 'mB20';
                this.dialogClass = 'w600';
                $('#errorModalDialogInvoiveError').modal();
            }
        );
    }

    openSelectOffersDialogAfterQuantityValidation() {
        this.multipleAddressValidation().then(
            (addressData: any) => {
                if (this.sendDocs) {
                    this.sendDocsToCustomer(Number(this.offers.offerList[0].offerId));
                } else {
                    this.selectedOfferRadio.setValue(String(this.offers.offerList[0].offerId));
                    $('#selectOfferModal').modal();
                }
            },
            (addressError: any) => {
                this.errorTitle = 'Sorry, we found a problem';
                this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
                this.errorMessageB = addressError.error.msg;
                this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                this.errorMessageBClass = 'mB20';
                this.dialogClass = 'w600';
                $('#errorModalDialogInvoiveError').modal();
            }
        );
    }

    validateQuantity() {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequest(
                environment.gateway + 'validateQuantity/' + this.applicationId, 'application/json').subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
        return promise;
    }

    multipleAddressValidation() {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.postRequest(
                environment.gateway + 'multipleaddressvalidation/', this.getInvoiceAddress(), 'application/json').subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
        return promise;
    }

    getInvoiceAddress() {
        const address = [];
        this.items.forEach(element => {
            address.push({
                city: element.iForm.city.value,
                county: element.iForm.county.value,
                state: element.iForm.state.value,
                zipCode: element.iForm.zip.value
            });
        });
        return address;
    }

    continueFromOffers(selectedOffer: number) {
        $('.carousel').carousel('next');
    }

    backFromOffers(selectedOffer: number) {
        $('#selectOfferModal').modal('hide');
    }

    continueFromSummary(selectedOffer: number) {
        if(this.isAmendment) {
            $('.carousel').carousel('next');
        } else {
            this.continueFromAmendment(selectedOffer);
        }
    }

    backFromSummary(selectedOffer: number) {
        $('.carousel').carousel('prev');
    }

    continueFromAmendment(selectedOffer: number) {
        $('#selectOfferModal').modal('hide');
        this.continueToDocs(selectedOffer);
    }

    backFromAmendment(selectedOffer: number) {
        $('.carousel').carousel('prev');
    }

    continueToDocs(selectedOffer: number) {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.postRequest(
                environment.gateway + 'offerAndEquipment/' + this.applicationId + '/' + this.authService.getUserId(),
                this.getInvoiceData(selectedOffer), 'application/json').subscribe(
                    (data: any) => {
                        this.router.navigateByUrl('/application/bankInfo', { state: { applicationId: this.applicationId } });
                        resolve(data);
                    },
                    (error: any) => {
                        this.errorTitle = 'Sorry, we found a problem';
                        this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
                        this.errorMessageB = error.error.msg;
                        this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                        this.errorMessageBClass = 'mB20';
                        this.dialogClass = 'w600';
                        $('#errorModalDialogInvoiveError').modal();
                        reject(error);
                    }
                );
        });
        return promise;
    }

    sendDocsToCustomer(selectedOffer: number) {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.postRequest(
                environment.gateway + 'equipment/' + this.applicationId + '/' + this.authService.getUserId(),
                this.getInvoiceData(selectedOffer), 'application/json').subscribe(
                    (data: any) => {
                        this.router.navigateByUrl('/application/docuSent', { state: { applicationId: this.applicationId } });
                        resolve(data);
                    },
                    (error: any) => {
                        this.errorTitle = 'Sorry, we found a problem';
                        this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
                        this.errorMessageB = error.msg;
                        this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                        this.errorMessageBClass = 'mB20';
                        this.dialogClass = 'w600';
                        $('#errorModalDialogInvoiveError').modal();
                        reject(error);
                    }
                );
        });
        return promise;
    }

    getInvoiceData(selectedOfferId: number) {
        const invoiceData = {
            equipmentList: [],
            offerId: selectedOfferId
        };

        this.items.forEach(element => {
            invoiceData.equipmentList.push(element.encode());
        });

        return invoiceData;
    }

    getInvoiceTotal() {
        let invoiceTotal = 0;
        this.items.forEach(element => {
            invoiceTotal += Number(element.iForm.equipmentCost.value);
        });
        return invoiceTotal;
    }

    addItemClick() {
        this.items.push(new InvoiceItem(this.formBuilder));
    }

    removeItemClick(item: InvoiceItem) {
        const index = this.items.indexOf(item);
        if (index > -1) {
            this.items.splice(index, 1);
        }
    }

    onZipCodeKeyUp(item: InvoiceItem) {
        this.getZipCodeData(item.iForm.zip.value).then(
            (data: any) => {
                if (data.object) {
                    item.cities = data.object.city;
                    item.states = this.statesOfIncorporation; // data.object.state example: "UT"
                    item.iForm.state.setValue(data.object.state);
                    item.counties = data.object.county;
                } else {
                    item.cities = [];
                    item.counties = [];
                }
            },
            (error: any) => {
                item.cities = [];
                item.counties = [];
            }
        );
    }

    onInvoiceNumberKeyUp(item: InvoiceItem) {
        if (item.iForm.invoiceNumber.value.length > 0) {
            item.iForm.make.setValue('See invoice: ' + item.iForm.invoiceNumber.value);
            item.iForm.model.setValue('See invoice: ' + item.iForm.invoiceNumber.value);
            item.iForm.year.setValue((new Date()).getFullYear().toString());
        } else {
            item.iForm.make.setValue('');
            item.iForm.model.setValue('');
            item.iForm.year.setValue('');
        }
    }

    onMakeOrModelOrYearKeyUp(item: InvoiceItem) {
        item.iForm.invoiceNumber.setValue('0');
    }

    onUseNumberSelected(item: InvoiceItem) {
        item.iForm.invoiceNumber.setValue('');
    }

    onNotUseNumberSelected(item: InvoiceItem) {
        item.iForm.invoiceNumber.setValue('0');
    }

    getZipCodeData(zipCode: string) {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequest(environment.gateway + 'application/zipData/' + zipCode, 'application/json').subscribe(
                (data: any) => {
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
        return promise;
    }

    openEditFinancedAmount() {
        this.openEditFinancedAmountPopover = true;
        this.changeDetector.detectChanges();
        this.financedAmountInput.nativeElement.focus();
        this.invoiceForm.controls.financedAmountInput.setValue(this.offers.requestAmount);
    }

    closeEditFinancedAmount() {
        this.openEditFinancedAmountPopover = false;
    }

    saveEditFinancedAmount() {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.postRequest(
                environment.gateway + 'application/' + Number(this.offers.offerList[0].offerId) + '/offerInvoiceRecalc/' + this.authService.getUserId(),
                { newRequestAmount: this.invoiceForm.controls.financedAmountInput.value }, 'application/json').subscribe(
                    (data: any) => {
                        this.openEditFinancedAmountPopover = false;
                        if (data.object) {
                            this.offers = data.object;
                            this.selectedOffer = {};
                            data.object.offerList.forEach((element: any) => {
                                if (element.selected) {
                                    this.selectedOffer = element;
                                }
                            });
                        }
                        resolve(data);
                    },
                    (error: any) => {
                        this.openEditFinancedAmountPopover = false;
                        reject(error);
                    }
                );
        });
        return promise;
    }

    onCompleteInformationClick() {
        const data = [{
            make: 'make',
            model: 'model',
            serialNumber: '1548724',
            year: 2018,
            description: 'Item Desc',
            cost: 15000,
            condition: 'true',
            streetAddress: '1182 Main St',
            city: 'SALT LAKE CITY',
            county: 'SALT LAKE',
            unit: '',
            state: 'UT',
            zipCode: '84105',
            lesseeAddress: true,
        }];

        this.items = [];
        this.useNumber.setValue('false');
        data.forEach((invoiceItem: any) => {
            const item = new InvoiceItem(this.formBuilder);
            item.decode(invoiceItem);
            this.onZipCodeKeyUp(item);
            this.items.push(item);
        });
        if (this.items.length === 0) {
            this.items.push(new InvoiceItem(this.formBuilder));
        }
    }
}
